<template>
  <div id="app">
    <Xplay />
  </div>
</template>

<script>
import Xplay from './components/Xplay.vue'

export default {
  name: 'App',
  components: {
    Xplay
  }
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100%;
}
</style>
